import * as _4 from 'lodash4';
import { Strategy } from 'utility-ts-strategy';
import { InTakeSurveyAnswer } from '../builders/ap_intake_survey_answer_builder';
import {
  ICheckboxQuestionMeta,
  IInTakeSurveyQuestionMeta,
  IRadioQuestionMeta
} from '../builders/ap_intake_survey_builder';
import { IInTakeSurveyQuestionChoice } from '../builders/ap_intake_survey_question_choice_builder';
import { ApIntakeSurveyDefaultAnswerStrategy } from './ap_intake_survey_default_answer_strategy';
import { IntakeSurveyAnswerStrategy } from './intake_survey_answer_strategy';

function findAnswerForQuestion(
  question: ICheckboxQuestionMeta,
  choices: IInTakeSurveyQuestionChoice[],
  answers: InTakeSurveyAnswer[]
): IInTakeSurveyQuestionChoice[];

function findAnswerForQuestion(
  question: IRadioQuestionMeta,
  choices: IInTakeSurveyQuestionChoice[],
  answers: InTakeSurveyAnswer[]
): IInTakeSurveyQuestionChoice;

function findAnswerForQuestion(
  question: IRadioQuestionMeta | ICheckboxQuestionMeta,
  choices: IInTakeSurveyQuestionChoice[],
  answers: InTakeSurveyAnswer[]
): IInTakeSurveyQuestionChoice[] | IInTakeSurveyQuestionChoice {
  let answer = IntakeSurveyAnswerStrategy[question._question_type](question, choices, answers);
  if (_4.isEmpty(answer) && question._computedNK) {
    answer = ApIntakeSurveyDefaultAnswerStrategy[question._computedNK](choices);
  }
  return answer;
}

export const ApIntakeSurveyAnswerStrategy = new Strategy({
  radio: findAnswerForQuestion,
  checkbox: findAnswerForQuestion
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/strategies/ap_intake_survey_answer_strategy.ts